module.exports = __webpack_public_path__ + "img/Logo_NoResults.699d3e26.svg";